// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";

export const XNGAGE_CUSTOM_WIDGET = "Xngage Custom" as any;
export const EMPTY_VALUE = "- -";
export const DivWrapper = `div[class^="Wrapper"]`;
export const ToasterWrapperSelector = `div[class^="ToasterWrapper"]`;
export const HEADER_HEIGHT_CSS_VAR = "--headerHeight";
export const ADD_TO_PROJECT = translate("Add to Project");

export const sharedDateTimeOptions: Intl.DateTimeFormatOptions = {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
};

export const SLIDES_PER_VIEW_POINTS = {
    xs: 0,
    sm: 1,
    md: 2,
    lg: 3,
};

export enum USER_ROLES {
    ADMIN = "Administrator",
    BUYER1 = "Buyer1",
    BUYER2 = "Buyer2",
    BUYER3 = "Buyer3",
    FINANCE = "Finance",
    REQUISITIONER = "Requisitioner",
}

export const placeHolders = {
    email: "eg. example@gmail.com",
    phone: "( ___ ) ___ - ____",
};

export const checkoutPages = ["CheckoutShippingPage", "CheckoutReviewAndSubmitPage", "OnePageCheckoutPage"];

export const constants = {
    header: {
        size: {
            height: 136,
        },
        mobile: {
            size: {
                height: 57,
            },
        },
        tablet: {
            size: {
                height: 56,
            },
        },
    },
    footer: {
        offsetTop: 48,
    },
};

export const productsScreenRegex = /^(2(\.\d+)?|3(\.\d+)?|4(\.\d+)?|5(\.\d+)?|6(\.0*)?|1(\.[1-9]\d*)?|1(\.\d{2,})?)$/;

export enum ShippingPreferences {
    ShipWhenAvailable = "Ship When Available",
    ShipWhenComplete = "Ship When Complete",
}

export enum PickUpPreferences {
    PickUpWhenReady = "Pick Up When Ready",
    PickUpWhenComplete = "Pick Up When Complete",
}

export const MAX_QTY = 99999;

export const TAX_EXEMPT_FORM_ID = "TaxExemptForm";
